import React, { useState } from 'react';
import SSOForm from './SSOForm/SSOForm';
import StandardForm from './StandardForm/StandardForm';
import './LoginForm.css';

export const LoginForm = () => {
    const [useSSO, setUseSSO] = useState(false);
    return (
        <>
            {useSSO ? (
                <SSOForm setSSO={setUseSSO} />
            ) : (
                <StandardForm setSSO={setUseSSO} />
            )}
        </>
    );
};

export default LoginForm;
